<template>
  <div class="main">
    <div class="background">
      <img class="background-image cloud-l" src="../assets/course/cloud_left.png" alt="">
      <img class="background-image cloud-r" src="../assets/course/cloud_right.png" alt="">
      <div class="book-index container-fluid">
        <div class="row">
          <div class="group-box">
            <div class="title-box">
              Disclaimer and AI-Generated Content Copyright Notice
            </div>
            <div class="line"></div>
            <div class="content-box ">
              <div>
                <div class="mb-2">
                  Some content and functions on this website are automatically generated by
                  Generative AI technology. While we strive to provide accurate and valuable
                  learning resources, AI-generated content may be incomplete, inaccurate, or
                  produce unexpected results. Users should verify the accuracy of any AI-
                  generated responses or content and use them with caution.
                </div>
                <h4 class="title">Disclaimer:</h4>
                <ol>
                  <li>
                    <span class="title">Content Accuracy:</span>
                    Any content provided by Generative AI is for reference
                    only. This website cannot guarantee it is fully correct or up-to-date; users
                    should verify and adjust as necessary. This website and its operators bear no
                    legal responsibility for any disputes, losses, or damages arising from reliance
                    on or use of the generated content.
                  </li>
                  <li>
                    <span class="title">Substitute for Professional Advice:</span>
                    Responses or content generated by
                    Generative AI should not be considered professional advice, legal opinions, or
                    authoritative answers. Users should seek independent legal advice or other
                    professional opinions based on their specific circumstances.
                  </li>
                  <li>
                    <span class="title">Technical Limitations:</span>
                    Generative AI has technical limitations, and
                    generated responses or content may not fully meet user needs or may result
                    in inappropriate or unsuitable outcomes in certain contexts. This website and
                    its operators cannot guarantee the completeness or suitability of generated
                    content.
                  </li>
                </ol>
                <h4 class="title">Intellectual Property Rights Notice:</h4>
                <ol>
                  <li>
                    <span class="title">AI-Generated Content:</span>
                    The Generative AI used on this website is based on
                    publicly available training data and open technology, and AI-generated
                    content is not controlled by specific sources or proprietary data. Due to the
                    automated nature of generated content, this website and its operators cannot
                    perform complete third-party intellectual property checks or controls on the
                    content, nor can they guarantee that users may assert copyright or other
                    intellectual property rights over AI-generated content.
                  </li>
                  <li>
                    <span class="title">Potential Third-Party References:</span>
                    AI-generated content may, at times,0
                    unintentionally imitate or reference pre-existing data or works. If any
                    infringement of third-party copyrights or other intellectual property rights is
                    discovered, please notify this website immediately. This website will act
                    promptly, including removing the relevant content.
                  </li>
                </ol>
                <h4 class="title">User Responsibilities:</h4>
                <ol>
                  <li>
                    Users are responsible for ensuring that any content created or transmitted on
                    this website does not violate any laws or infringe on the rights of others.
                  </li>
                  <li>
                    Users are responsible for ensuring that their use of AI-generated content from
                    this website complies with copyright and intellectual property laws. In cases of
                    redistribution, sharing, or commercial use, users must obtain any necessary
                    permissions or licenses. This website and its operators bear no legal
                    responsibility for any losses or damages arising from users’ violation of laws
                    or misuse of AI-generated content.
                  </li>
                </ol>
                <div class="my-2">
                  This website reserves the right to modify this Disclaimer and Intellectual
                  Property Rights Notice at any time. Users should periodically review the
                  disclaimer and notice to stay informed of the relevant policies and any
                  changes.
                </div>
                <h4 class="title">Sources:</h4>
                <span class="source" @click="goSource">
                  MICROSOFT Responsible AI Documentation
                </span>
                <br>
                <span class="source" @click="goOpenAI">
                  OPENAI Terms of Use
                </span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'Disclaimer',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goSource () {
      window.open('https://support.microsoft.com/ja-jp/topic/%E8%B2%AC%E4%BB%BB%E3%81%82%E3%82%8B-ai-%E3%81%A8%E3%81%AF-33fc14be-15ea-4c2c-903b-aa493f5b8d92', '_blank')
    },
    goOpenAI () {
      window.open('https://openai.com/zh-Hant/policies/terms-of-use/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    .background {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      background-color: blue;
      background: linear-gradient(to bottom, rgb(57, 57, 248) 0%, rgb(94, 92, 252) 100%);
      z-index: 10;
      .background-image {
        position: fixed;
        bottom: 0;
        z-index: -5;
      }
      .cloud-l {
        left: 0;
      }
      .cloud-r {
        right: 0;
      }
    }
    .book-index {
      margin: 20vh 10vw 10vh 10vw;
      width: 60vw;
      min-height: 80vh;
      border: 10px solid orangered;
      border-radius: 30px;
      background-color: #fff;
      padding: 5vh 5vw;

      .boxSizing{
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box;    /* Firefox, other Gecko */
        box-sizing: border-box;         /* Opera/IE 8+ */
      }
      .group-box {
        width: 100%;
      }
      .line {
        width:100%;
        height:4px;
        background-color:#fc5f00;
      }
      .title-box {
        padding: 10px 3px;
        color: #fff;
        border-radius: 5px 5px 0 0;
        font-size: 2rem;
        background-color: #ff731c;
      }
      .content-box {
        position: relative;
        width:100%;
        padding: 20px;
        border-left:1px #cee0ff solid;
        border-right:1px #cee0ff solid;
        border-bottom:1px #cee0ff solid;
        background-color:#f4f4f4;
        border-bottom-left-radius:10px;
        border-bottom-right-radius:10px;
        font-size: 1.5rem;
        text-align: left;
        overflow: hidden;
        .title {
          font-weight: bolder;
        }
        .source {
          cursor: pointer;
          text-decoration: underline;
          color: red;
        }
      }
    }
  }
</style>
